import axios, { InternalAxiosRequestConfig } from 'axios'

import { ENV } from '../../Environment'
import { GlobalContextInterface } from '../../Types/core'
import { API_ROUTES } from '../../constants/apiRoutes'
import { generateTraceparent } from '../../utils/generateTraceparent'
import { getCookie } from '../../utils/getCookies'

const globalContext: GlobalContextInterface = JSON.parse(
  sessionStorage.getItem('globalContext') ?? 'null',
)

const headers = {
    bsSolution: API_ROUTES.leadsInfo.bsSolution,
    bsWebMethod: API_ROUTES.leadsInfo.bsWebMethod,
    bsWebService: API_ROUTES.leadsInfo.bsWebService,
    bsUser: ENV().leadsVariables.leadsUser,
    bsSubscriptionKey: ENV().leadsVariables.leadsSubscriptionKey,
    'aip-subscriptionKey': ENV().leadsVariables.leadsAipSubscriptionKey,
    Authorization: "Token",
};

export const apiLeads = axios.create({ baseURL: API_ROUTES.leadsUrl, headers })

apiLeads.interceptors.request.use((config: InternalAxiosRequestConfig) => {
  const username = getCookie('pts_username')
  config.headers['aip-user'] = username || globalContext?.username || ''
  config.headers.traceparent = generateTraceparent()
  return config
})
